













import { mdiDelete } from "@mdi/js";
import { Vue, Component, Prop } from "vue-property-decorator";
import { vxm } from "@/store";
import EventBonus from "@/domain/event-bonus";

@Component({})
export default class BonusCard extends Vue {
  @Prop() bonus!: EventBonus;

  loading = false;
  deleteIcon = mdiDelete;
  showActions = false;

  async deleteBonus() {
    this.loading = true;
    await vxm.results.deleteBonus(this.bonus.id);
    this.loading = false;
  }
}
